import { axiosGET } from 'src/services/axiosService';
import { IScoreResponse } from '../types/IScoreResponse';

export const findScoreByCnpjAssertiva = async (
  cnpj: string | undefined,
): Promise<IScoreResponse> => {
  try {
    const endpoint = `${process.env.REACT_APP_PUBLIC_BACKEND}/assertiva-integration/score/cnpj/${cnpj}`;
    const response = await axiosGET<IScoreResponse>(endpoint);

    return response.data;
  } catch (error: any) {
    throw new Error(
      error?.message ? error.message : 'Ocorreu um erro, tente novamente.',
    );
  }
};
